import * as React from "react";
import type { SVGProps } from "react";
const LockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <rect
      x="4"
      y="8"
      width="12"
      height="8"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M7 8V6a3 3 0 1 1 6 0v2" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="10" cy="12" r="1" fill="currentColor" />
  </svg>
);
export default LockIcon;
